/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';

const ArrRightButton = (props) => (
    <div className="boxBtn-inner">
      <div className={`ico-right ${!!props.className ? props.className : ''}`}></div>
    </div>
);

export default ArrRightButton;



// WEBPACK FOOTER //
// ./src/browser/components/buttons/ArrRightButton.js